import { isValidPath } from 'frameworks_drivers/routes';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { TrackerUtil } from 'tracking/TrackerUtil';

export default function usePathBasedPageTracking() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (isValidPath(pathname)) {
      TrackerUtil.trackPage(TrackerUtil.getPageName());
    }
  }, [pathname]);

  return null;
}
